// @mui icons
import Icon from "@mui/material/Icon";

// Images
import profilePicture from "../assets/images/team-5.jpg";
import WDAvatar from "../MaterialComponents/WDAvatar";
import CustomerRoute from "./routes/CustomerRoute";
import adminRoute from "./routes/AdminRoute";
import { getPartnerRoutes } from "./routes/PartnerRoute";
import agentRoute from "./routes/AgentRoute";
import customerProRoute from "./routes/CustomerProRoute";
import customerEmployeeRoute from "./routes/CustomerEmployeeRoute";

const getAppRoutes = () => {
  try {
    // Get auth info from localStorage
    let authInfo = localStorage.getItem("authInfo");
    if (!authInfo) {
      console.warn("No auth info found in localStorage");
      return [];
    }
    
    // Parse auth info
    const parsedAuthInfo = JSON.parse(authInfo);
    if (!parsedAuthInfo || !parsedAuthInfo.principalInfo) {
      console.warn("Invalid auth info structure", parsedAuthInfo);
      return [];
    }
    
    // Get user info
    const auth = parsedAuthInfo.principalInfo;
    const userType = auth.userType;
    const roles = auth.roles || [];
    console.log("User type:", userType, "Roles:", roles);
    
    // Check for CUSTOMER_EMPLOYEE role first (highest priority)
    if (Array.isArray(roles) && roles.includes("CUSTOMER_EMPLOYEE")) {
      console.log("Using CUSTOMER_EMPLOYEE routes");
      return customerEmployeeRoute;
    }
    
    // Return routes based on user type
    if (userType === "CUSTOMER_ORG") {
      if (Array.isArray(roles) && roles.includes("CUSTOMER_ORG_PRO")) {
        return customerProRoute;
      }
      return CustomerRoute;
    } else if (userType === "ADMIN_ORG") {
      console.log("Using admin routes");
      // For admin users, we don't need to check roles - they're already admin
      return adminRoute;
    } else if (userType === "PARTNER_ORG" || userType === "CHANNEL_PARTNER_ORG") {
      console.log("Using partner routes for:", userType);
      // Call getPartnerRoutes() dynamically to get correct routes based on current user type
      return getPartnerRoutes();
    } else {
      console.warn("Unknown user type:", userType);
      return [];
    }
  } catch (error) {
    console.error("Error getting app routes:", error);
    return [];
  }
};
export default getAppRoutes;
